<script>
import IconEnvelope from "@js/components/Icons/IconEnvelope.vue";
import IconMapPoint from "@js/components/Icons/IconMapPoint.vue";
import IconWhatsApp from "@js/components/Icons/IconWhatsApp.vue";
import IconTelegram from "@js/components/Icons/IconTelegram.vue";

export default {
    name: "ContactSocialsList",
    components: {IconTelegram, IconWhatsApp, IconMapPoint, IconEnvelope},
    props: {
        darker: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<template>
    <div
        :class="{'bg-[#2D2D2D]/50':darker, 'bg-white/10':!darker}"
        class="backdrop-blur-xl p-5 border border-[#FFFFFF80] rounded-xl w-full max-w-[575px] flex flex-col items-center justify-center">
        <p class="text-white font-bold text-lg md:text-xl">
            Не хотите звонить? Напишите!
        </p>
        <p class="text-sm md:text-md text-white">
            Все способы связаться с нами онлайн
        </p>
        <div class="grid grid-cols-4 mt-5 gap-5">
            <!--WhatsApp-->
            <a href="https://api.whatsapp.com/send/?phone=79256649222&text&type=phone_number&app_absent=0"
               target="_blank" class="flex flex-col items-center min-w-[75px]">
                <div class="w-10 h-10 rounded-full bg-white flex items-center justify-center">
                    <IconWhatsApp class="w-5 h-5 text-indigo-600"/>
                </div>
                <div
                    class="text-white font-normal text-xs md:text-sm mt-2">
                    WhatsApp
                </div>
            </a>
            <!--WhatsApp-->
            <!--Telegram-->
            <a href="https://t.me/Dorozhnyeplity"
               target="_blank" class="flex flex-col items-center min-w-[75px]">
                <div class="w-10 h-10 rounded-full bg-white flex items-center justify-center">
                    <IconTelegram class="w-5 h-5 text-indigo-600 -ms-0.5"/>
                </div>
                <div
                    class="text-white font-normal text-xs md:text-sm mt-2">
                    Telegram
                </div>
            </a>
            <!--Telegram-->
            <!--Yandex-->
            <a href="https://yandex.com/maps/-/CHqNiWk4"
               target="_blank" class="flex flex-col items-center min-w-[75px]">
                <div class="w-10 h-10 rounded-full bg-white flex items-center justify-center">
                    <IconMapPoint class="w-5 h-5 text-indigo-600"/>
                </div>
                <div
                    class="text-white font-normal text-xs md:text-sm mt-2">
                    Карты
                </div>
            </a>
            <!--Yandex-->
            <!--Почта-->
            <a href="mailto:sale@dorozhnyeplity.ru" class="flex flex-col items-center min-w-[75px]">
                <div class="w-10 h-10 rounded-full bg-white flex items-center justify-center">
                    <IconEnvelope class="w-5 h-5 text-indigo-600"/>
                </div>
                <div
                    class="text-white font-normal text-xs md:text-sm mt-2">
                    Почта
                </div>
            </a>
            <!--Почта-->
        </div>
    </div>

    <!--    <div class="grid grid-cols-3 md:grid-cols-5 items-center justify-center mt-5 overflow-hidden max-w-[600px] gap-5 md:gap-0">-->
    <!--        <div v-for="i in 5" class="flex">-->
    <!--            <a target="_blank" href="#"-->
    <!--               class="flex flex-col items-center ps-3 pe-3 pt-3 pb-3 rounded-xl bg-white shadow border-2 border-gray-200 hover:border-indigo-600 transition">-->
    <!--                <div-->
    <!--                    class="w-9 md:w-10 h-9 md:h-10 rounded-full bg-white border border-indigo-600 p-2 flex items-center justify-center">-->
    <!--                    <svg class="w-5 md:w-6 h-5 md:h-6" viewBox="0 0 24 24" fill="none"-->
    <!--                         xmlns="http://www.w3.org/2000/svg">-->
    <!--                        <ellipse cx="12.0005" cy="12" rx="12.0005" ry="12" fill="#4241B8"/>-->
    <!--                        <g clip-path="url(#clip0_1509_31100)">-->
    <!--                            <ellipse cx="11.9928" cy="11.9982" rx="10.0006" ry="10.0002"-->
    <!--                                     fill="#4241B8"/>-->
    <!--                            <path-->
    <!--                                d="M17.7532 13.7925C17.7064 13.7701 15.9567 12.9085 15.6457 12.7966C15.5188 12.751 15.3828 12.7065 15.2382 12.7065C15.0019 12.7065 14.8034 12.8242 14.6488 13.0555C14.474 13.3153 13.9449 13.9338 13.7814 14.1185C13.7601 14.1429 13.7309 14.1721 13.7135 14.1721C13.6978 14.1721 13.427 14.0606 13.345 14.025C11.468 13.2097 10.0433 11.249 9.84792 10.9184C9.82002 10.8709 9.81885 10.8493 9.81862 10.8493C9.82547 10.8241 9.88859 10.7608 9.92117 10.7282C10.0165 10.6339 10.1197 10.5096 10.2196 10.3894C10.2669 10.3324 10.3143 10.2754 10.3608 10.2216C10.5058 10.053 10.5703 9.92207 10.6451 9.77043L10.6843 9.69165C10.867 9.32876 10.711 9.02252 10.6605 8.92364C10.6192 8.84088 9.88033 7.05784 9.80178 6.87051C9.61289 6.41848 9.36329 6.20801 9.01644 6.20801C8.98425 6.20801 9.01644 6.20801 8.88147 6.2137C8.71712 6.22063 7.82213 6.33845 7.42642 6.58788C7.00679 6.85243 6.29688 7.69572 6.29688 9.17876C6.29688 10.5135 7.14394 11.7738 7.50762 12.2531C7.51666 12.2651 7.53326 12.2897 7.55734 12.3249C8.95012 14.3589 10.6864 15.8662 12.4465 16.5693C14.1411 17.2462 14.9435 17.3244 15.3996 17.3244H15.3997C15.5914 17.3244 15.7449 17.3094 15.8802 17.296L15.9661 17.2878C16.5515 17.2359 17.8379 16.5694 18.1305 15.7563C18.361 15.1158 18.4218 14.4161 18.2684 14.1621C18.1634 13.9894 17.9824 13.9025 17.7532 13.7925Z"-->
    <!--                                fill="white"/>-->
    <!--                            <path-->
    <!--                                d="M12.2137 0C5.71341 0 0.424994 5.24845 0.424994 11.6996C0.424994 13.7862 0.983416 15.8286 2.04127 17.6162L0.0165024 23.5886C-0.0212141 23.7 0.00683945 23.8231 0.0892079 23.9069C0.148666 23.9677 0.22932 24.0004 0.311689 24.0004C0.343249 24.0004 0.375043 23.9956 0.406058 23.9857L6.63396 22.0068C8.33821 22.9173 10.2644 23.398 12.2138 23.398C18.7135 23.398 24.0014 18.1501 24.0014 11.6996C24.0014 5.24845 18.7135 0 12.2137 0ZM12.2137 20.9609C10.3794 20.9609 8.60278 20.4313 7.07557 19.4292C7.02421 19.3954 6.9646 19.3781 6.9046 19.3781C6.87288 19.3781 6.84109 19.383 6.81015 19.3928L5.50033 18.5003L4.69748 17.4133C4.73005 17.3171 4.71377 17.2111 4.65376 17.1291C3.49079 15.5401 2.87602 13.6627 2.87602 11.6996C2.87602 6.59231 7.06489 2.43713 12.2137 2.43713C17.3618 2.43713 21.5502 6.59231 21.5502 11.6996C21.5503 16.8063 17.362 20.9609 12.2137 20.9609Z"-->
    <!--                                fill="#4241B8"/>-->
    <!--                        </g>-->
    <!--                        <defs>-->
    <!--                            <clipPath id="clip0_1509_31100">-->
    <!--                                <rect width="24.0014" height="24.0004" fill="white"/>-->
    <!--                            </clipPath>-->
    <!--                        </defs>-->
    <!--                    </svg>-->
    <!--                </div>-->
    <!--                <div-->
    <!--                    class="text-[#2D2D2D] border-[#2D2D2D] font-normal text-xs md:text-sm mt-2 border-b-2 pb-[2px]">-->
    <!--                    WhatsApp-->
    <!--                </div>-->
    <!--            </a>-->
    <!--        </div>-->
    <!--    </div>-->
</template>

<style scoped lang="scss">

</style>
